import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router";
import store from '../../../../../Redux/store';
import { Autocomplete, IconButton, Skeleton, TextField, Tooltip } from '@mui/material';
import { convertDateFormat } from '../../../../../Js/Date';
import CategorySearchandFilter from '../../../../Single Components/CategorySearchandFilter';
import CustomPagination from '../../../../Single Components/CustomPagination';
import ReactToPrint from 'react-to-print';
import ExcelJS from "exceljs"
import PrintComponentList from "../../../SalesNew/SalesReport/TableListPrint"
import { listGstrReportAPICall } from './TrailBalanceAPI';

export const GstrReport = () => {
  const filtereDataOptions = useSelector((state) => state.listCategory);
  let navigate = useNavigate();
  const printRef = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [FormDataInfo, setFormDataInfo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [filteredDatas, setFilteredData] = useState({});
  const [gstrData, setGstrData] = useState({
    branchDetails: {},
    reportPeriod: {},
    totals: {
      saleCount: 0,
      returnCount: 0,
      b2b: { count: 0, taxableAmount: 0, taxAmount: 0, invoiceAmount: 0 },
      b2cLarge: { count: 0, taxableAmount: 0, taxAmount: 0, invoiceAmount: 0 },
      b2cSmall: { count: 0, taxableAmount: 0, taxAmount: 0, invoiceAmount: 0 },
      exports: { count: 0, taxableAmount: 0, taxAmount: 0, invoiceAmount: 0 }
    },
    pagination: { totalPages: 1 }
  });


  const { branchDetails } = useSelector((state) => state.mainDashBoardSlice);
  const userInfo = useSelector((state) => state.loginResponseSlice.value);

  const [validationAlert, setValidationAlert] = useState({});

  const formInitialState = {
    branch: branchDetails,
    startDate: '',
    endDate: '',
  };

  const [formValues, setFormValues] = useState(formInitialState);

  const getFormInfo = (key) => (e) => {
    const { value } = e?.target || {};
    setValidationAlert({});
    setFormValues({
      ...formValues,
      [key]: value
    });
  };

  //  const fetchGstrData = async (branchId, fromDate, endDate) => {
  //   try {
  //     setIsLoading(true);
  //     const response = await listGstrReportAPICall({
  //       branchId,
  //       fromDate,
  //       endDate,
  //       page: currentPage,
  //       limit: 10
  //     });

  //       console.log(listGstrReportAPICall,"list time report data.!")

  //     setGstrData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching GSTR data:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const fetchGstrData = async (branchId, fromDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await listGstrReportAPICall({
        branchId,
        fromDate,
        endDate,
        page: currentPage,
        limit: 10
      });
      setGstrData(response.data); // Now response will contain the data
      console.log(response, "response fetchGStrData.!")
    } catch (error) {
      console.error("Error fetching GSTR data:", error);
      // You might want to set some error state here
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterSubmit = (filters) => {
    // Get the branch ID with fallbacks
    const branchId = filters?.branchList?._id ||
      selectedBranch?._id ||
      branchDetails?._id ||
      '';

    // Get dates with fallbacks
    const fromDate = filters?.fromDate ? `${filters.fromDate} 00:00:00` : '';
    const endDate = filters?.toDate ? `${filters.toDate} 23:59:59` : '';

    if (!branchId) {
      console.error("No branch ID available for GSTR report");
      return;
    }

    fetchGstrData(branchId, fromDate, endDate);
  };

  const downloadList = () => {
    if (!gstrData) return;

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("GSTR Report");
    sheet.properties.defaultRowHeight = 20;

    // Add header section
    const titleRow = sheet.addRow(["GSTR Report"]);
    titleRow.font = { size: 15, bold: true };
    sheet.mergeCells("A1:H1");
    titleRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };

    // Add branch details
    const branchRow = sheet.addRow([
      `Branch: ${gstrData.branchDetails.name} (${gstrData.branchDetails.trnNumber})`
    ]);
    sheet.mergeCells("A2:H2");
    branchRow.getCell(1).alignment = { horizontal: "center" };

    // Add report period
    const periodRow = sheet.addRow([
      `Report Period: ${gstrData.reportPeriod.fromDate} to ${gstrData.reportPeriod.endDate}`
    ]);
    sheet.mergeCells("A3:H3");
    periodRow.getCell(1).alignment = { horizontal: "center" };

    // Add empty row
    sheet.addRow([]);

    // Add summary section
    const summaryHeader = sheet.addRow(["Category", "Count", "Taxable Amount", "Tax Amount", "Invoice Amount"]);
    summaryHeader.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
    });

    // Add summary data
    const categories = ['b2b', 'b2cLarge', 'b2cSmall', 'exports'];
    categories.forEach(category => {
      sheet.addRow([
        category.toUpperCase(),
        gstrData.totals[category].count,
        gstrData.totals[category].taxableAmount,
        gstrData.totals[category].taxAmount,
        gstrData.totals[category].invoiceAmount
      ]);
    });

    // Add totals row
    sheet.addRow([
      "TOTAL",
      gstrData.totals.saleCount,
      "", // No total for taxable amount
      "", // No total for tax amount
      ""  // No total for invoice amount
    ]);

    // Generate the Excel file
    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "GSTR_Report.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  useEffect(() => {
    // Only fetch if we have a valid branch ID
    if (branchDetails?._id) {
      fetchGstrData(branchDetails._id, '', '');
    }
  }, [currentPage, branchDetails]);

  const handleDataFromChild = (data) => {
    setFormDataInfo(data);
    handleFilterSubmit(data);
  };

  const handleFilterChange = (updatedItems) => {
    setFilteredData(updatedItems);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleBranchSelect = (selectedBranch) => {
    setSelectedBranch(selectedBranch);
  };

  return (
    <div className='global-page-parent-container updated-global-page-parent-container'>
      <div className="justify-space-between list-create-head-bar">
        <h3>GSTR Report</h3>
        <div className="create-head-buttons-container">
          
          <div className="justify-center" style={{ gap: "10px",  justifyContent: "flex-end" }}>
            <CategorySearchandFilter
              onData={handleDataFromChild}
              onBranchSelect={handleBranchSelect}
              onFilterChange={handleFilterChange}
              isDateRange={true}
              isSearch={false}
            />
            <PrintComponentList contentRef={printRef} />
            <Tooltip title="Download">
              <span>
                <IconButton
                  style={{
                    backgroundColor: "#ffd2d2",
                    color: "#002995",
                    borderRadius: "0",
                    height: "38px",
                    width: "37px",
                  }}
                  onClick={downloadList}
                >
                  <i className="bi bi-arrow-down-circle"></i>
                </IconButton>
              </span>
            </Tooltip>
                 

          </div>
          
        </div>
      </div>

      <div className="justify-space-between pagination-container">
        {gstrData && (
          <h3>
            Branch: {gstrData.branchDetails.name}
            {/* |
            TRN: {gstrData.branchDetails.trnNumber} |
            Period: {gstrData.reportPeriod.fromDate} to {gstrData.reportPeriod.endDate} */}
          </h3>
        )}
        {gstrData && (
          <CustomPagination
            currentPage={currentPage}
            totalPages={gstrData.pagination.totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>

      <div className='new-global-table-container updated-table-container' ref={printRef}>
        {/* Summary Section */}
        {gstrData && (
          <div className="gstr-summary-section">
            <h4>Summary</h4>
            <div className="summary-grid">
              <div className="summary-card">
                <h5>Total Vouchers</h5>
                <p>{gstrData.totals.saleCount}</p>
              </div>
              <div className="summary-card">
                <h5>Returns</h5>
                <p>{gstrData.totals.returnCount}</p>
              </div>
            </div>

            <h4>Category Breakdown</h4>
            <table className="category-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Count</th>
                  <th>Taxable Amount</th>
                  <th>Tax Amount</th>
                  <th>Invoice Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>B2B</td>
                  <td>{gstrData.totals.b2b.count}</td>
                  <td>{gstrData.totals.b2b.taxableAmount}</td>
                  <td>{gstrData.totals.b2b.taxAmount}</td>
                  <td>{gstrData.totals.b2b.invoiceAmount}</td>
                </tr>
                <tr>
                  <td>B2C Large</td>
                  <td>{gstrData.totals.b2cLarge.count}</td>
                  <td>{gstrData.totals.b2cLarge.taxableAmount}</td>
                  <td>{gstrData.totals.b2cLarge.taxAmount}</td>
                  <td>{gstrData.totals.b2cLarge.invoiceAmount}</td>
                </tr>
                <tr>
                  <td>B2C Small</td>
                  <td>{gstrData.totals.b2cSmall.count}</td>
                  <td>{gstrData.totals.b2cSmall.taxableAmount}</td>
                  <td>{gstrData.totals.b2cSmall.taxAmount}</td>
                  <td>{gstrData.totals.b2cSmall.invoiceAmount}</td>
                </tr>
                <tr>
                  <td>Exports</td>
                  <td>{gstrData.totals.exports.count}</td>
                  <td>{gstrData.totals.exports.taxableAmount}</td>
                  <td>{gstrData.totals.exports.taxAmount}</td>
                  <td>{gstrData.totals.exports.invoiceAmount}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {isLoading ? (
          <div className="loading-skeleton">
            {[...Array(5)].map((_, i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                animation="wave"
                width={"100%"}
                height={40}
                style={{ marginBottom: '10px' }}
              />
            ))}
          </div>
        ) : !gstrData ? (
          <div className="no-data">No data available</div>
        ) : null}
      </div>

      {/* Add some CSS for the summary cards */}
      <style jsx>{`
        .gstr-summary-section {
          margin-bottom: 20px;
        }
        .summary-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;
          margin-bottom: 20px;
        }
        .summary-card {
          border: 1px solid #ddd;
          border-radius: 5px;
          padding: 15px;
          text-align: center;
          background-color: #f9f9f9;
        }
        .summary-card h5 {
          margin: 0 0 10px 0;
          color: #555;
        }
        .summary-card p {
          margin: 0;
          font-size: 1.5em;
          font-weight: bold;
          color: #555;
        }
        .category-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 20px;
        }
        .category-table th, .category-table td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }
        .category-table th {
          background-color: #f2f2f2;
        }
        .category-table tr:nth-child(even) {
          background-color: #f9f9f9;
        }
      `}</style>
    </div>
  )
}